import React from "react";
import { Modal } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

export default function ModalInvalidReferralToken() {
  const [t] = useTranslation();

  return (
    <Modal
      open={true}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      dimmer="blurring"
      style={{ maxWidth: 600 }}
    >
      <Modal.Content style={{ textAlign: "center" }}>
        <Modal.Header as="h2">
            {t("referral_token_header")}
          </Modal.Header>
        {t('referral_token_copy')}
        <br/>
        <br/>
        <span
          className="link"
          onClick={() => {
            // remove bad referralToken from URL
            document.location.href = document.location.href.replace(/referralToken=[^&]+/, '').replace('?&', '?')
          }}>
          {t('referral_token_continue')}
        </span>
      </Modal.Content>
    </Modal>
  );
}
